const TeamPageTitle = () => {
  return (
    <section className="text-center text-blue-900 bg-blue-100 border-b border-blue-200">
      <h1 className="text-4xl font-bold mt-8">Team of UpScore.ai</h1>
      <h2 className="text-2xl mt-5 mb-8">
        UpScore.ai was created by experienced developers with expertise in AI,
        in collaboration with IELTS experts
      </h2>
    </section>
  );
};

export default TeamPageTitle;
